import { Controller } from "@hotwired/stimulus"

// Контроллер для управления выбором двух менеджеров
export default class extends Controller {
  static targets = ["manager1", "manager2", "hiddenField"]

  connect() {
    // Инициализируем значения полей при загрузке страницы
    this.initializeManagerFields()
    // Обновляем скрытое поле
    this.updateManagerIds()
  }

  initializeManagerFields() {
    // Получаем текущие manager_ids из скрытого поля
    const managerIdsString = this.hiddenFieldTarget.value
    if (managerIdsString) {
      const managerIds = managerIdsString.split(',').filter(id => id && id !== "")
      
      // Устанавливаем значения полей
      if (managerIds[0]) {
        this.manager1Target.value = managerIds[0]
      }
      if (managerIds[1]) {
        this.manager2Target.value = managerIds[1]
      }
    }
  }

  updateManagerIds() {
    const manager1Id = this.manager1Target.value
    const manager2Id = this.manager2Target.value
    
    // Собираем массив ID менеджеров, исключая пустые значения
    const managerIds = [manager1Id, manager2Id].filter(id => id && id !== "")
    
    // Обновляем скрытое поле
    this.hiddenFieldTarget.value = managerIds.join(",")
    
    // Логируем для отладки
    console.log("Manager IDs updated:", managerIds)
  }
}
